import React, { useState, useEffect } from 'react';
import styles from './SignUp.module.scss';
import { Container, Row, Col, Form, Image } from 'react-bootstrap';
import { CustomButton } from '../shared/customButton';
import { CustomTextField } from '../shared/customTextField';
import { CustomTextFieldPass } from '../shared/textFieldPass';
import { CustomAlertBox } from '../shared/customAlertBox';
import { signUp, signin } from '../../services/util/auth';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';

const SignUp = (props) => {

    //create states
    const [isLoading, setStatus] = useState(false);
    const [message, setMessage] = useState();
    const [show, setShow] = useState(false);
    let history = useNavigate();

    //yup validations
    const schema = yup.object({
        companyName: yup.string()
            .trim()
            .max(50, 'Maximum length is 50 characters')
            .matches(/^[^\uD83C-\uDBFF\uDC00-\uDFFF\u{1F300}-\u{1F9FF}\u{1F1E6}-\u{1F1FF}]*$/u, 'Remove emojis')
            .matches(/^[^<>=*$^]*$/, 'Remove restricted characters such as: < > = $ * ^')
            .test('no-links', 'Links are not allowed', value => {
                if (value) {
                    return !/(http(s)?:\/\/|www\.)[^\s]+/gi.test(value); // Checks if the string contains any URLs starting with http(s):// or www.
                }
                return true; // Allow empty strings
            })
            .required('Required'),
        companyemail: yup.string().email('Invalid email').trim().required('Required'),
        password: yup.string().min(8, 'Minimum length is 8 characters').required('Required')
    }); 

    const formFocus = () => {
        setShow(false)
    }

    //on submit function
    const onSubmit = async (values) => {
        setStatus(true)
        let response = await signUp(values.companyemail, values.password, values.companyName);
        if (response.success === true) {
            let respond = await signin(values.companyemail, values.password);
            if (respond.success === true) {
                ReactGA.event('sign_up')
                localStorage.setItem('email', values.companyemail);
                setStatus(false)
                history({
                    pathname: '/email-verify',
                })
            }

        }
        else {
            setMessage(response.msg)
            setStatus(false)
            setShow(true)
        }
    }

    useEffect(() => {
        ReactGA.initialize([{
            trackingId: `${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`
        }]);

        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    }, [])

    return (
        <div>
            <Helmet>
                <title>Sign Up | HireTrace</title>
            </Helmet>
            <Row className={styles.mainRowSignup}>
                <Col xs={12} md={6} className={styles.leftBar}>
                    <Container>
                        <Col className={styles.topicColumn}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 40C25.4247 40 40 25.4247 40 0C40 25.4247 54.5753 40 80 40C54.5753 40 40 54.5753 40 80C40 54.5753 25.4247 40 0 40Z" fill="white" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C7.62742 12 12 7.62742 12 0C12 7.62742 16.3726 12 24 12C16.3726 12 12 16.3726 12 24C12 16.3726 7.62742 12 0 12Z" fill="#FEC84B" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M64 24C69.0849 24 72 21.0849 72 16C72 21.0849 74.9151 24 80 24C74.9151 24 72 26.9151 72 32C72 26.9151 69.0849 24 64 24Z" fill="#FEC84B" />
                            </svg>
                            <p className={styles.topicDesc}>
                                Start your Free Trial                               
                            </p>
                            <p className={styles.secondDesc}>Create a free account and get full access to all features for <br /> 14-days. No credit card needed. Get started in 2 minutes.</p>

                        </Col>
                        <Col className={styles.bottomColum}>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_1.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_2.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_3.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_4.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_5.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userTexteDiv}>
                                <p className={styles.bottomDesc}>Join 5,000+ Talent Professionals</p>
                            </div>

                        </Col>
                    </Container>
                </Col>
                <Col xs={12} md={6}>
                    <Container className={styles.mainContainer}>
                        <Row>
                            <Col className={styles.leftColumnMain}>
                                <div className={styles.companySecondLogoDiv}>
                                    <a href="/" target="_blank" rel="noreferrer">
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/favicon (1).ico`} rounded fluid className={styles.companyLogo} />
                                    </a>
                                </div>
                                <div className={styles.companyLogoTextDiv}>
                                    <p>Hiretrace</p>
                                </div>
                            </Col>
                            <Col className={styles.rightColumnMain}>
                                <p className={styles.rightColumnTopText}>Have an account?</p>
                                <Link to="/signin" className={styles.rightColumnTopSecondText}>
                                    Log in
                                </Link>
                            </Col>
                        </Row>
                        <Container>
                            <Row className={styles.createAccountRow}>
                                <Col sm={10} xl={6} className={styles.createAccountDiv}>
                                    <p className={styles.createAccountTitle}>Sign up</p>
                                    <p className={styles.createAccountSubTitle}>Start your 14-day free trial today. No credit card required.</p>
                                </Col>
                            </Row>
                            {show === true &&
                                (<Row className={styles.alertRow}>
                                    <Col sm={10} xl={6} className={styles.alertColumn}>
                                    <CustomAlertBox alertBodyText={message} errorMessageId="signUp_errorMsgId" alertType='dangerAlert'/>
                                    </Col>
                                </Row>)
                            }

                            <Row className={styles.formRow}>
                                <Col sm={10} xl={6}>
                                    <Formik
                                        validationSchema={schema}
                                        onSubmit={(values) => onSubmit(values)}
                                        initialValues={{}}>

                                        {({
                                            errors,
                                            handleChange,
                                            handleSubmit,
                                            submitCount
                                        }) => (
                                            <Form noValidate onSubmit={handleSubmit} onFocus={() => formFocus()}>
                                                <Col className={styles.inputFieldsColumns}>
                                                    <CustomTextField
                                                        label="Company Name*"
                                                        classLabel="defaultLabel"
                                                        controlId="companyName"
                                                        type="text"
                                                        name="companyName"
                                                        placeholder="Enter your company name"
                                                        classType="defaultTextBox"
                                                        handleOnChange={handleChange}
                                                        errorMessage={errors.companyName}
                                                        validationMessageId="signUp_companyName_companyNameValidationMsgId"
                                                        isInvalid={submitCount > 0 && !!errors.companyName}
                                                    />
                                                </Col>
                                                <Col className={styles.inputFieldsColumns}>
                                                    <CustomTextField
                                                        label="Email*"
                                                        classLabel="defaultLabel"
                                                        controlId="companyemail"
                                                        type="email"
                                                        name="companyemail"
                                                        placeholder="Enter your email"
                                                        classType="defaultTextBox"
                                                        handleOnChange={handleChange}
                                                        errorMessage={errors.companyemail}
                                                        validationMessageId="signUp_companyEmail_companyEmailValidationMsgId"
                                                        isInvalid={submitCount > 0 && !!errors.companyemail}
                                                    />
                                                </Col>
                                                <Col className={styles.inputFieldsColumns}>
                                                    <CustomTextFieldPass
                                                        label="Password*"
                                                        classLabel="defaultLabel"
                                                        controlId="Password"
                                                        name="password"
                                                        placeholder="Set password for min 8 characters"
                                                        classType="defaultTextBox"
                                                        handleOnChange={handleChange}
                                                        errorMessage={errors.password}
                                                        validationMessageId="signUp_password_companyPasswordValidationMsgId"
                                                        isInvalid={
                                                            submitCount > 0 && !!errors.password
                                                        }
                                                    />
                                                </Col>
                                                <Col sm={12} className='mt-5 p-0'>

                                                    {<CustomButton
                                                        buttonType="submit"
                                                        id="signUp_submitBtnId"
                                                        label="Sign Up"
                                                        type="primaryBtn"
                                                        disabled={isLoading === true ? true : false}
                                                        backicon=
                                                        {isLoading === true ?
                                                            <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                                            : ''
                                                        }

                                                    />}


                                                </Col>

                                                <Col className={styles.colWithNoSidePaddings}> 
                                                    <p className={styles.signupBottomMessage}>By clicking the "Sign Up" button, you're agreeing to  </p>
                                                    <p className={styles.termsPara}><a href="/privacy-policy" target="_blank" rel="noreferrer" className={styles.termsLink}>Privacy Policy</a> and <a href="/terms-and-conditions" target="_blank" rel="noreferrer" className={styles.termsLink}>Terms of Use</a> of HireTrace</p>
                                                </Col>
                                            </Form>
                                        )}
                                    </Formik>
                                </Col>
                            </Row>
                        </Container>
                        <Row className={styles.bottomRow}>
                            <Col >
                            </Col>
                            <Col>
                                <div className={styles.helpEmailDiv}>
                                    <p className={styles.helpText}>© Hiretrace 2024</p>
                                </div>

                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </div>
    )

}




export default SignUp;